import React from "react";
import logoImage from "../assets/logo.svg";

const Footer = () => {
  return (
    <>
      <div
        id="contact"
        className="w-full bg-[#f7f7f7] px-4 md:px-24 lg:px-28 py-20"
      >
        <div className="grid lg:grid-cols-3">
          <div className="lg:col-span-2 mb-8 sm:mb-0">
            <div className="flex items-center">
              <img src={logoImage} alt="logo" />
              <h2 className="ml-2 md:ml-2">WalletCloud</h2>
            </div>
            <p className="text-justify text-[#828282] lg:w-3/5 my-6 sm:my-8 ">
              Connect to our blockchain wallet service and seamlessly carry out
              transactions. Securely initiate crypto transactions, and store
              them with one simple integration.
            </p>
            <p className="px-8 py-4 md:px-8 bg-[#219563] text-white cursor-pointer max-w-[10rem] text-center hover:-translate-y-1">
              Get the API
            </p>
          </div>
          <div className="col-span-1">
            <div className="flex justify-between">
              <div>
                <h3>Company</h3>
                <p className="text-[#828282]">Home</p>
                <p className="text-[#828282]">Products</p>
                <p className="text-[#828282]">Documentation</p>
                <p className="text-[#828282]">Contact us</p>
              </div>
              <div className="pr-12 sm:pr-0">
                <h3>Support</h3>
                <p className="text-[#828282]">Documentation</p>
                <p className="text-[#828282]">Security</p>
                <p className="text-[#828282]">FAQs</p>
                <p className="text-[#828282]">Privacy Policy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center p-2 bg-[#219653] text-white">
        <p className="">
          Design .&amp; Code by
          <a
            href="https://twitter.com/toyosill"
            target="_blank"
            rel="noreferrer"
            className="text-black"
          >
            {" "}
            Toyosi Lawal{" "}
          </a>
          .&amp;
          <a
            href="https://fatadedotun.netlify.app/"
            target="_blank"
            rel="noreferrer"
            className="text-black"
          >
            {" "}
            Adedotun Fatokun
          </a>
        </p>
        <p>All rights Reserved &copy; 2022</p>
      </div>
    </>
  );
};

export default Footer;
